import { render, staticRenderFns } from "./menuDependiente.vue?vue&type=template&id=16d37072&"
import script from "./menuDependiente.vue?vue&type=script&lang=js&"
export * from "./menuDependiente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports